module.exports = __webpack_public_path__ + "media/images/sports_coaching/card-mobile@3x-0c44ffa845b2dfdd14823852ff800076.jpg";